import { APP_STATE } from '../../../constants'
import {
  MASTER_RULES_RECEIVED,
  OUTGOING_RULES_RECEIVED,
  OUTGOING_CHANGED,
} from './actions'

export const initialState = {
  stateOfAction: APP_STATE.FETCHING,
  inputList: [],
  outputList: [],
  incoming: [],
  selectedOutgoing: undefined,
  errorMsg: '',
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case APP_STATE.FETCHING:
      return {
        ...state,
        stateOfAction: APP_STATE.FETCHING,
      }

    case APP_STATE.ERROR:
      return {
        ...state,
        errorMsg: action.msg,
        stateOfAction: APP_STATE.ERROR,
      }

    case APP_STATE.DONE:
      return {
        ...state,
        stateOfAction: APP_STATE.DONE,
      }

    case MASTER_RULES_RECEIVED:
      return {
        ...state,
        inputList: action.data,
        stateOfAction: APP_STATE.DONE,
      }

    case OUTGOING_RULES_RECEIVED:
      return {
        ...state,
        outputList: action.data,
        stateOfAction: APP_STATE.DONE,
      }

    case OUTGOING_CHANGED:
      return {
        ...state,
        selectedOutgoing: action.selectedOutgoing,
        stateOfAction: APP_STATE.DONE,
      }

    default:
      return state
  }
}
